import React from "react";
import styles from "css/mobile/mypage.module.css";
import axios from "axios";
import style from "css/mypage.module.css";
import { useTranslation } from "react-i18next";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import { useDispatch } from "react-redux";

function ResDetailInfoFile({ index, value, marginTop }) {
  const dispatch = useDispatch();
  const downloadFile = (params) => {
    axios
      .post("/schedule/downloadFile", params, { responseType: "blob" })
      .then((response) => response.data)
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", params.ORI_FILE_NM);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };
  const { t, i18n } = useTranslation();

  return (
    <div
      className={styles.detailInfo_container}
      style={{ marginTop: `${marginTop}px` }}
    >
      <div className={styles.info_index}>{index}</div>
      <div className={styles.info_value}>
        {value && Object.keys(value).length === 0 ? (
          ""
        ) : value.FILE_INFO.length > 3 ? (
          (value.attachmentlist || []).map((data, index) => (
            <div key={index} style={{ marginBottom: "5px" }}>
              <span
                onClick={() => downloadFile(data)}
                className={style.detailpop_content_aTag}
              >
                {data.ORI_FILE_NM}
              </span>
            </div>
          ))
        ) : (
          <div>{t("LABEL.NO_ATTACHMENT")}</div>
        )}
      </div>
    </div>
  );
}

export default ResDetailInfoFile;
